<template lang="pug">
.FMadeInFrance(:style="style")
  .FMadeInFrance__flag
    .FMadeInFrance__flag--blue
    .FMadeInFrance__flag--white
    .FMadeInFrance__flag--red
  p.FMadeInFrance__text {{ text }}
</template>

<style lang="stylus">
.FMadeInFrance
  &__flag
    width var(--FMadeInFrance--width)
    height rem(7.5)
    display flex

    > *
      flex 1 1 0%

    &--blue
      background-color var(--color--secondary--light-1)

    &--white
      background-color var(--color--neutral--light-5)

    &--red
      background-color var(--color--primary)

  &__text
    use-font('body-2')
    margin-top rem(5)
</style>

<script setup lang="ts">
export interface FMadeInFranceProps {
  /**
   * width of the flag
   */
  width?: number;
  /**
   * text under the flag
   */
  text: string;
}

const props = withDefaults(defineProps<FMadeInFranceProps>(), {
  width: 180,
});

const style = computed(
  (): Style => ({
    '--FMadeInFrance--width': genSize(props.width),
  })
);
</script>
